import {
	getRootClassNames,
	SwanProvider,
	useBrowserClasses,
	SWAN_STYLE_KEY_MAP,
	SwanHead,
	ScreenClassProvider,
} from "@vp/swan"
import * as React from "react"
import {Helmet} from "react-helmet"

const styleSheetKeys = [
	SWAN_STYLE_KEY_MAP.accordion,
	SWAN_STYLE_KEY_MAP.alertBox,
	SWAN_STYLE_KEY_MAP.button,
	SWAN_STYLE_KEY_MAP.carousel,
	SWAN_STYLE_KEY_MAP.core,
	SWAN_STYLE_KEY_MAP.grid,
	SWAN_STYLE_KEY_MAP.hidden,
	SWAN_STYLE_KEY_MAP.icon,
	SWAN_STYLE_KEY_MAP.modalDialog,
	SWAN_STYLE_KEY_MAP.progressiveImage,
	SWAN_STYLE_KEY_MAP.standardTile,
	SWAN_STYLE_KEY_MAP.table,
	SWAN_STYLE_KEY_MAP.toggleSwitch,
	SWAN_STYLE_KEY_MAP.visible,
]

const SwanConfiguration = (props: any) => {
	const browserClassName = useBrowserClasses()
	const bodyClassName = getRootClassNames()
	return (
		<SwanProvider>
			<Helmet htmlAttributes={{class: browserClassName}} bodyAttributes={{class: bodyClassName}} />
			<SwanHead renderStyleContentAsChildren renderWith={Helmet} styleSheetKeys={styleSheetKeys} />
			<ScreenClassProvider>{props.children}</ScreenClassProvider>
		</SwanProvider>
	)
}

export default SwanConfiguration
